import React, { FC, useEffect, useMemo, useState } from 'react'
import { shallowEqual } from 'react-redux';
import { useAppSelector as useSelector } from '../../../../../app/common/_customHooks/redux';
import { useNavigate, useLocation } from 'react-router-dom';
import { selectors } from "../../../../../app/user-access/_redux";
import { RootState } from '../../../../../redux/store';
import { IUserFields } from "../../../../../app/user-access/_interfaces";

import "./HeaderMenu.scss"
import { useTranslation } from 'react-i18next';

interface IProps {
    selectedTabIndex?:number;
}

const filterCustomerTabs = (paths: any[], userFields: IUserFields) => {
    if (!paths) return [];

    const hasCredit = userFields?.customer_credit?.isEnabled;
    const hasClassification = userFields?.customer_classification?.isEnabled;
    const hasWholesalers = userFields?.customer_wholesalers?.isEnabled;

    const rules: Record<string, boolean> = {
        greditData: hasCredit, // Typo is intentional to match the tab value --- FIX on BE/DataBase first
        blockData: hasCredit,
        classificationData: hasClassification,
        wholesalers: hasWholesalers,
    };

    return paths.filter(p => {
        const rule = rules[p.value];
        return rule === undefined ? true : rule;
    });
};

const HeaderNavigation:FC<IProps> = ({ selectedTabIndex = 0 }) => {
    const navigate = useNavigate();
    const location = useLocation();
    const { t } = useTranslation();
    const [tab, setTab] = useState<number>(selectedTabIndex);

    const paths = useSelector((state:RootState) => { return selectors.getTabMenu(state)}, shallowEqual);
    const userFields:IUserFields = useSelector(selectors.getUserFields);

    const filteredPaths = useMemo(() => {
        //for customers data page filtering the tabs based on parameters enabled/disabled
        if (location.pathname !== "/masterdata/customersdata/general") return paths;
        return filterCustomerTabs(paths, userFields);
    }, [location.pathname, paths, userFields]);


    useEffect(() => {
        return () => {
            setTab(0);
        }
    }, []);

    useEffect(() => {
        const { pathname } = location;
        const currentItemIdx =
            filteredPaths.findIndex(({url}: {url:string}) => url === pathname);

        if (currentItemIdx >= 0) setTab(currentItemIdx);
    }, [location.pathname, filteredPaths]);

    const onTabClick = (index:number, url:string) => {
        setTab(index);
        navigate(url);
    }

    if (!filteredPaths || filteredPaths.length === 0) return <div />;

    return (
        <div className={`NavigationMenuContainer ${filteredPaths.length > 0 && 'w-100'}`}>
            <ul
                className="nav nav-tabs nav-pills grey-nav-pills align-items-center"
                role="tablist"
            >
                {filteredPaths.map(({url, label}: {url:string, label:string}, idx:number) => (
                    <li className="nav-item" onClick={() => onTabClick(idx, url)} key={idx}>
                        <span
                            className={`nav-link cursor-pointer ${tab === idx && "active"}`}
                            data-toggle="tab"
                            role="tab"
                            aria-selected={tab === idx}
                        >
                            {t(`TabNav.${label}`)}
                        </span>
                    </li>
                ))}
            </ul>
        </div>
    );
}

export default HeaderNavigation